var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"instead"}},[_c('v-main',[_c('router-view')],1),_c('Snackbar'),_c('Loader'),_c('GoToTopFAB')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }